import Axios from 'axios'
var qs = require('qs')

const pendencies = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.PENDENCY_API_URL
    return AxiosInstance
  },
  getPendencies(labId, offset, limit, startDate, endDate, status, typeOfSearch, q, orderBy) {
    return this.axios().post('/' + labId, {
      limit,
      offset: offset * limit,
      startDate,
      endDate,
      status,
      findTypeOrderResultFilter: typeOfSearch,
      query: q,
      orderBy
    })
  },
  obtainQuantityPendencies(labId, startDate, endDate, status, typeOfSearch, q) {
    return this.axios().post('/quantity/' + labId, {
      endDate: endDate,
      startDate: startDate,
      status,
      query: q,
      findTypeOrderResultFilter: typeOfSearch
    })
  },
  resolvePendency(pendencyId, resolution) {
    return this.axios().put('/resolve/' + pendencyId, null, {
      params: {
        resolution: resolution
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, {
          indices: false
        })
      }
    })
  },
  downloadDocumentUploaded(fileId) {
    return this.axios().get('/download/' + fileId, {
      responseType: 'arraybuffer'
    })
  },
  uploadDocumentPendency(idLab, document, idPendency) {
    let formData = new FormData()
    formData.append('name', document.file)

    return this.axios().post('/upload/' + idLab, formData, {
      params: {
        'id-pendency': idPendency
      }
    })
  },
  deleteDocumentPendency(uuid) {
    return this.axios().delete('/attachment/' + uuid)
  },
  getTransferedFile(id) {
    return this.axios().get('/download/transmission?idTransferedFile=' + id, {
      responseType: 'arraybuffer'
    })
  }
}

export default pendencies
